export const STEP_NAME_PLACEHOLDER = 'Untitled step';
export const ADDING_STEP_TEXT = 'Adding step...';
export const ADD_STEP_BUTTON_CID_PREFIX = 'addStep_';
